import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from 'src/app/core/models/order';

export enum ConfirmDeliveryResult { DeliverdToClient, DeliveredAtDoor, Cancel }

@Component({
    selector: 'app-confirm-delivery',
    templateUrl: './confirm-delivery.component.html',
    styleUrls: ['./confirm-delivery.component.scss'],
})
export class ConfirmDeliveryComponent {
    @Input({ required: true }) order!: Order;
    @Output() onResult: EventEmitter<ConfirmDeliveryResult> = new EventEmitter<ConfirmDeliveryResult>();
    isConfirmingDelivery = false;


    deliveredToClient(): void {
        if (this.isConfirmingDelivery) return;
        this.isConfirmingDelivery = true;
        this.onResult.emit(ConfirmDeliveryResult.DeliverdToClient);
    }

    deliveredAtDoor(): void {
        if (this.isConfirmingDelivery) return;
        this.isConfirmingDelivery = true;
        this.onResult.emit(ConfirmDeliveryResult.DeliveredAtDoor);
    }

    close(): void {
        this.onResult.emit(ConfirmDeliveryResult.Cancel);
    }
}
